var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.ready)?_c('el-container',[_c('el-aside',[_c('adnav',[_vm._v("1")])],1),_c('router-view')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }